import API from "../services/api-request";

export default {
  data() {
    return {
      tourCategory: [],
      editedTourCategory: "",
      editedTourCategoryId: "",

      restoCategory: [],
      editedRestoCategory: "",
      editedRestoCategoryId: "",

      subsTypes: "",
      type: "",
      editedSubsType: "",
      validity: "",
      price: "",
      description: "",
      categoryToShow: "",
      showEditDiv: false,
      showEditDivResto: false,
      showEditDivSubstype: false,
    };
  },
  methods: {
    //Tour
    //Tour
    //Tour
    //Tour
    CategoryInfo() {
      API.index("tour-category-all").then((response) => {
        this.tourCategory = response.data;
      });
    },
    //Update status
    updateTourCategory(category) {
      let status;
      if (category.status == 1) {
        status = 0;
      } else {
        status = 1;
      }
      API.update(category.id, { status: status }, "tour-category").then(
        (response) => {
        }
      );
    },
    showTourCategory(category) {
      this.showEditDiv = true;
      this.editedTourCategory = category.type;
      this.editedTourCategoryId = category.id;
    },
    editTourCategory() {
      API.update(
        this.editedTourCategoryId,
        {
          type: this.editedTourCategory,
        },
        "tour-category"
      ).then((response) => {
        this.showEditDiv = false;
        this.CategoryInfo();
        this.successAlertMessage();
      });
    },
    //Resto
    //Resto
    //Resto
    //Resto
    restoCategoryInfo() {
      API.index("resto-category-all").then((response) => {
        this.restoCategory = response.data;
      });
    },
    //Update status
    updateRestoCategory(category) {
      let status;
      if (category.status == 1) {
        status = 0;
      } else {
        status = 1;
      }

      API.update(category.id, { status: status }, "resto-category").then(
        (response) => {}
      );
    },
    showRestoCategory(category) {
      this.showEditDivResto = true;
      this.editedRestoCategory = category.name;
      this.editedRestoCategoryId = category.id;
    },
    editRestoCategory() {
      API.update(
        this.editedRestoCategoryId,
        {
          name: this.editedRestoCategory,
        },
        "resto-category"
      ).then((response) => {
        this.showEditDivResto = false;
        this.restoCategoryInfo();
        this.successAlertMessage();
      });
    },

    //Substype
    //Substype
    //Substype
    //Substype
    subsTypesInfo() {
      API.index("substype-all").then((response) => {
        this.subsTypes = response.data;
      });
    },
    //Update status
    updateSubsType(subs) {
      let status;
      if (subs.status == 1) {
        status = 0;
      } else {
        status = 1;
      }

      API.update(subs.id, { status: status }, "substype").then(
        (response) => {}
      );
    },
    showEditSubsType(subs) {
      this.showEditDivSubstype = true;
      this.type = subs.name;
      this.price = subs.price;
      this.validity = subs.validity;
      this.description = subs.description;
      this.editedSubsTypeId = subs.id;
    },
    editSubsType() {
      API.update(
        this.editedSubsTypeId,
        {
          name: this.type,
          price: this.price,
          validity: this.validity,
          description: this.description,
        },
        "substype"
      ).then((response) => {
        this.showEditDivSubstype = false;
        this.subsTypesInfo();
        this.successAlertMessage();
      });
    },
    successAlertMessage() {
      this.$swal.fire({
        position: "top-end",
        icon: "success",
        title: "Modifications éffectuée avec succès ! ",
        showConfirmButton: false,
        timer: 1500,
      });
    },
  },
  mounted() {
    this.CategoryInfo();
    this.subsTypesInfo();
    this.restoCategoryInfo();
    this.categoryToShow = this.$route.params.category;
  },
};
